import { Component } from '@angular/core';
import { Auth } from '../../services/auth';

@Component({
  selector: 'app-system-down',
  imports: [],
  templateUrl: './system-down.html',
  styleUrl: './system-down.scss'
})

export class SystemDown {
    systemDownIcon = 'assets/images/system-down.svg';
    exclaimIcon = 'assets/images/exclaim.svg';

    constructor(private authService: Auth) {}

    refreshPage(): void {
      window.location.reload();
    }

    logout(): void {
      console.log('Logging out...');
      this.authService.initiateLogout();
    }
}
